export default `https://react-academy-meta.netlify.com/default.jpg`;
